import React from "react";

import { tw } from "~/utils";

type CopyrightProps = {
  className?: string;
};

export const Copyright = ({ className }: CopyrightProps) => {
  return (
    <div className={tw("pt-8", className)}>
      <p className="text-sm text-gray-500">
        © {new Date().getFullYear()}, Elektra Health
      </p>
    </div>
  );
};
